<template>
  <div>
    <div class="page-title-container lighter-shadow worker-page-title">

      <div v-if="!isProfilePictureLoading"
           :style="{backgroundImage: `url(${workerProfilePicture ? workerProfilePicture : getDefaultPicture})`}"
           class="profile-image">
      </div>

      <div v-if="isProfilePictureLoading"
           class="profile-image">
        <span v-if="isProfilePictureLoading">
          <i class="fa-6x fas fa-circle-notch fa-spin profile-picture-loading-icon"></i>
      </span>
      </div>

      <h1 class="worker-name" v-text="workerName" v-if="!isWorkerLoading"></h1>

      <ImageUploader @image-upload="changeProfileImage" class="image-uploader"/>
    </div>

    <TabContainer :tabs="tabs"/>

    <div class="page-content lighter-shadow" style="margin-bottom: 50px;">
      <div class="tab-content">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import redirectService from "@/services/redirect.service";
import {mapGetters} from 'vuex';
import TabContainer from "@/shared/components/TabContainer";
import ImageUploader from "@/shared/components/form/ImageUploader";
import utilService from "@/services/util.service";
import workerService from "@/services/worker.service";

export default {
  name: "WorkerProfile",
  components: {ImageUploader, TabContainer},
  created() {
    if (this.$route.path === '/staff/' + this.workerId) {
      redirectService.redirectToWorkerProfile(this.workerId);
      return;
    }

    this.$store.dispatch('fetchWorker', this.workerId);
    this.$store.dispatch('fetchWorkerProfilePicture', this.workerId);
    this.$store.dispatch('fetchAllWorkerQualifications');
    this.$store.dispatch('fetchAllRegions');
  },
  data() {
    return {
      workerId: this.$route.params.id,
      tabs: [
        {
          id: 'PersonalInfo',
          link: 'personal-information',
          name: 'Лични данни',
          icon: 'far fa-address-card',
        },
        {
          id: 'ProfessionProfile',
          link: 'professional-experience',
          name: 'Професионален профил',
          icon: 'fas fa-user-tie'
        },
        {
          id: 'Documents',
          link: 'documents',
          name: 'Документи',
          icon: 'far fa-file-alt'
        },
        {
          id: 'ContactInfo',
          link: 'contacts',
          name: 'Контакти',
          icon: 'fas fa-phone-alt'
        },
        {
          id: 'Notes',
          link: 'notes',
          name: 'Бележки',
          icon: 'far fa-comment-alt'
        }
      ],
    }
  },
  methods: {
    changeProfileImage(image) {
      this.profileImage = image;
      workerService.updateProfilePicture(this.workerId, image)
          .then(({data}) => this.$store.commit('setProfilePicture', data));
    }
  },
  computed: {
    ...mapGetters(['personalInfo', 'isWorkerLoading', 'isProfilePictureLoading', 'workerProfilePicture']),

    workerName() {
      const firstName = this.personalInfo.firstName ? this.personalInfo.firstName : '';
      const middleName = this.personalInfo.middleName ? this.personalInfo.middleName : '';
      const lastName = this.personalInfo.lastName ? this.personalInfo.lastName : '';
      return firstName + ' ' + middleName + ' ' + lastName;
    },
    getDefaultPicture() {
      return utilService.getDefaultProfilePicture();
    }
  },
  destroyed() {
    this.$store.commit('setPersonalInfo', {});
  }
}
</script>

<style scoped>
@import '../../css/shared/tabs.css';

.profile-image {
  width: 300px;
  height: 300px;
  margin: 25px;
  box-sizing: border-box;
  display: inline-block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid var(--light-grey);
}

.tab-content {
  width: 100%;
  float: left;
  box-sizing: border-box;
  padding: 25px;
}

.image-uploader {
  position: absolute;
  margin-left: 375px;
  margin-top: 290px;
  height: fit-content;
}

.worker-name {
  margin-top: 75px;
  font-size: 45px;
  float: left;
  width: calc(100% - 400px);
  height: fit-content;
}

.worker-page-title {
  height: 350px;
  display: flex;
}

.profile-picture-loading-icon {
  color: var(--slight-light-blue);
  margin: 100px;
}
</style>
